import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  MenuItem,
  Typography,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { SelectedMenu } from 'components'
import { fetchTaskGroups } from 'api/taskGroups/api'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import PropTypes from 'prop-types'
import AddTaskGroupDialog from './AddTaskGroupDialog'
import TaskGroupsTable from './TaskGroupsTable'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const TaskGroupsContainer = ({ team }) => {
  const [open, setOpen] = useState(false)
  const [taskGroupsList, setTaskGroupsList] = useState([])
  const [taskGroup, setTaskGroup] = useState(null)
  const [eventFilter, setEventFilter] = useState('ALL')
  const [statusFilter, setStatusFilter] = useState('OPEN')
  const [paramsObj, setParamsObj] = useState({})
  const featureGuard = useFeatureAccessGuard()

  const loadTaskGroups = async (params = {}) => {
    try {
      const res = await fetchTaskGroups(team.uuid, params)
      setTaskGroupsList(res.data)
    } catch (error) {
      console.error('Error fetching task groups:', error)
    }
  }

  const { enabled: hasTaskGroupManagerEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.task_manager_enabled
  )

  const handleOpen = (selectedTaskGroup) => {
    if (featureGuard(hasTaskGroupManagerEnabled)) return

    setTaskGroup(selectedTaskGroup)
    setOpen(true)
  }
  const handleFilter = (event, type) => {
    const { value } = event.target
    let params = { ...paramsObj }

    switch (type) {
      case 'EVENT_TYPE':
        setEventFilter(value)
        if (value !== 'ALL') {
          params = { ...params, 'filter[event_type]': value }
        } else {
          delete params['filter[event_type]']
        }
        break
      case 'STATUS':
        setStatusFilter(value)
        if (value === 'COMPLETED') {
          params = { ...params, 'filter[completed]': true }
        } else {
          delete params['filter[completed]']
        }
        break

      default:
        break
    }

    setParamsObj(params)
    loadTaskGroups(params)
  }

  const handleClose = () => {
    setOpen(false)
  }
  useEffect(() => {
    loadTaskGroups(paramsObj)
  }, [])

  return (
    <Grid container spacing={3}>
      {open && (
        <AddTaskGroupDialog
          open={open}
          onClose={handleClose}
          onSuccess={() => loadTaskGroups(paramsObj)}
          selectedTaskGroup={taskGroup}
        />
      )}
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <Typography variant="h4">
          <Translate id="task-management.title" />
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardHeader
            title={
              <Typography variant="h4" component="h4">
                <Translate id="task-management.next-tasks" />
              </Typography>
            }
            action={
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpen(null)}
                endIcon={
                  !hasTaskGroupManagerEnabled ? (
                    <LockIconComponent context="primaryButton" />
                  ) : null
                }
              >
                <Translate id="task-management.add-task" />
              </Button>
            }
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={2}>
                <SelectedMenu
                  id="task-group-event-type"
                  value={eventFilter}
                  onChange={(event) => handleFilter(event, 'EVENT_TYPE')}
                  label={<Translate id="task-management.select-task-type" />}
                >
                  <MenuItem value="ALL">
                    <Translate id="matches.all" />
                  </MenuItem>
                  <MenuItem value="TRAINING">
                    <Translate id="menu.training" />
                  </MenuItem>
                  <MenuItem value="MATCH">
                    <Translate id="button.match" />
                  </MenuItem>
                  <MenuItem value="GENERAL">
                    <Translate id="task-management.general-cat" />
                  </MenuItem>
                </SelectedMenu>
              </Grid>
              <Grid item xs={12} md={2}>
                <SelectedMenu
                  id="filter-select-task-status"
                  value={statusFilter}
                  onChange={(event) => handleFilter(event, 'STATUS')}
                  label={<Translate id="task-management.select-task-status" />}
                >
                  <MenuItem value="OPEN">
                    <Translate id="task-management.open" />
                  </MenuItem>
                  <MenuItem value="COMPLETED">
                    <Translate id="home.completed" />
                  </MenuItem>
                </SelectedMenu>
              </Grid>
            </Grid>
            <TaskGroupsTable
              taskGroupsList={taskGroupsList}
              handleOpen={handleOpen}
              onChange={() => loadTaskGroups(paramsObj)}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

TaskGroupsContainer.propTypes = {
  team: PropTypes.shape().isRequired,
}
export default compose(
  withRouter,
  connect(({ team }) => ({ team }))
)(TaskGroupsContainer)
